import { Dropdown } from "primereact/dropdown";
import React from "react";
import { Message } from "primereact/message";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Growl } from "primereact/growl";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Checkbox } from 'primereact/checkbox';
import { Dialog } from 'primereact/dialog';

import servicioObjetos from '../servicio/ServicioObjetos';
import servicioHttp from "../servicio/ServicioHttp";
import servicioFormatos from '../servicio/ServicioFormatos';
import servicioArchivos from '../servicio/ServicioArchivos';
import { CALENDARIO_ES_MX, FORMATO_FECHA_CALENDAR } from '../servicio/ServicioConstantes';

const JOIN_PRINCIPAL = {
    "tcTrabajador": "alias_tcTrabajador",
    "tcEmpresa": "alias_tcEmpresa"
};
const TODOS = { label: "TODOS", value: null };
const TODAS = { label: "TODAS", value: null };

export default class BusquedaDeIncidencias extends React.Component {

    constructor() {
        super();
        this.state = {
            consulta: {},
            registrosPatronales: [],
            errores: {},
            tipoDeIncidencias: [
                TODAS,
                { label: "AUSENTISMO", value: 11 },
                { label: "INCAPACIDAD", value: 12 }
            ],
            mostrarCalendarios: true,
            paginacion: {
                registrosPorPagina: 10,
                registrosTotales: 0
            },
            incidenciasSeleccionadas: [],
            mostrarModalConfirmacion:false
        };
    }

    componentDidMount() {
        this.obtenerRegistrosPatronales();
    }

    consultarIncidencias = () => {
        this.asignarRestricciones();
        let { paginacion } = this.state;
        servicioHttp.consumirPostHttp("incidencia/consultar_incidencia.json", paginacion).then(response => {
            this.setState({ paginacion: response.data.objeto });
        }).catch(error => {
        });
    }

    obtenerRegistrosPatronales = () => {
        servicioHttp.consumirPostHttp('empresa/obtener_registro_patronal.json').then(response => {
            let registrosPatronales = [TODOS];
            var newArray = registrosPatronales.concat(response.data.lista);
            let { consulta } = this.state;
            consulta.registroPatronal = TODOS.value;
            consulta.tipoDeIncidencia = TODAS.value;
            this.setState({ registrosPatronales: newArray, consulta: consulta });
        }).catch(error => {

        });
    };

    asignarValores = (event) => {
        servicioObjetos.asignarAtributosObjeto(event, this, false);
    };

    asignarRestricciones = () => {
        let { consulta, paginacion, registrosPatronales, tipoDeIncidencias } = this.state;
        paginacion.join = JOIN_PRINCIPAL;
        paginacion.restriccionesDinamicas = [];
        if (!servicioObjetos.esObjetoVacio(consulta.registroPatronal)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "alias_tcEmpresa.id",
                valorPropiedad: consulta.registroPatronal
            });
        } else {
            let empresasUsuarioSesion = [];
            for (let index = 0; index < registrosPatronales.length; index++) {
                let elemento = registrosPatronales[index];
                if (!servicioObjetos.esObjetoVacio(elemento.value)) {
                    let valor = elemento.value;
                    empresasUsuarioSesion.push(
                        valor
                    );
                }
            }
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "in",
                nombrePropiedad: "alias_tcEmpresa.id",
                coleccionIn: empresasUsuarioSesion
            });
        }

        let fechaInicial = servicioFormatos.formatearFechaString(consulta.fechaInicial);
        let fechaFinal = servicioFormatos.formatearFechaString(consulta.fechaFinal).replace('00:00:00', '23:59:59');
        paginacion.restriccionesDinamicas.push({
            tipoRestriccion: "between",
            nombrePropiedad: "fecha",
            valorPropiedad: null,
            fechaIncialBetween: fechaInicial,
            fechaFinalBetween: fechaFinal
        });

        if (!servicioObjetos.esObjetoVacio(consulta.tipoDeIncidencia)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "eq",
                nombrePropiedad: "tipo",
                valorPropiedad: consulta.tipoDeIncidencia
            });
        } else {
            let tiposIncidencia = [];
            for (let index = 0; index < tipoDeIncidencias.length; index++) {
                let elemento = tipoDeIncidencias[index];
                if (!servicioObjetos.esObjetoVacio(elemento.value)) {
                    let valor = elemento.value;
                    tiposIncidencia.push(
                        valor
                    );
                }
            }
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: "in",
                nombrePropiedad: "tipo",
                coleccionIn: tiposIncidencia
            });
        }
    }

    buscar = () => {
        let { consulta } = this.state;
        const validacion = this.validarFormulario(consulta);
        this.setState({ errores: validacion });
        if (!Object.keys(validacion).length) {
            let { paginacion, idsenube } = this.state;
            paginacion.numeroPagina = 0;
            idsenube = 0;
            this.setState({
                idsenube: idsenube,
                incidenciasSeleccionadas: []
            });
            this.asignarRestricciones();
            this.consultarIncidencias();
        }
    }

    validarFormulario = (consulta) => {
        const errores = {};
        if (servicioObjetos.esObjetoVacio(consulta.registroPatronal))
            errores.registroPatronal = "Seleccione Registro Patronal";
        if (servicioObjetos.esObjetoVacio(consulta.tipoDeIncidencia))
            errores.tipoDeIncidencia = "Seleccione una incidencia";
        if (servicioObjetos.esObjetoVacio(consulta.fechaInicial))
            errores.fechaInicial = "Seleccione Fecha Inicial";
        if (servicioObjetos.esObjetoVacio(consulta.fechaFinal))
            errores.fechaFinal = "Seleccione Fecha FInal";
        return errores;
    }

    reiniciarFrmBusqueda = () => {
        this.setState({
            consulta: {},
            mostrarCalendarios: false,
            fecha: {},
            errores: {}
        });
        setTimeout(() => {
            this.setState({ mostrarCalendarios: true });
        }, 50);
        this.obtenerRegistrosPatronales();
    }

    cambiaPagina = (event) => {
        this.asignarRestricciones();
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ idsenube: event.first });
        this.consultarIncidencias();
    }

    seleccionarIndicencias = (e, rowData) => {
        let { incidenciasSeleccionadas } = this.state;
        if (e.checked) {
            incidenciasSeleccionadas.push(rowData);
        } else {
            let index = incidenciasSeleccionadas.indexOf(rowData);
            incidenciasSeleccionadas.splice(index, 1);
        }
        this.setState({ incidenciasSeleccionadas: incidenciasSeleccionadas });
        rowData.checked = e.checked;
    }

    plantillaCheckBox = (rowData, column) => {
        return <Checkbox inputId="seleccionado" onChange={(e) => this.seleccionarIndicencias(e, rowData)} checked={rowData.checked} ></Checkbox>
    }

    onIndexTemplate = (data, props) => {
        let { idsenube } = this.state;
        return (props.rowIndex + 1) + idsenube;
    }

    templateFecha = (rowData, column) => {
        return servicioFormatos.formatearFecha(rowData.fechaIncidencia);
    }

    eliminarIncidencias = () => {
        let { incidenciasSeleccionadas } = this.state;
        if (!servicioObjetos.esObjetoVacio(incidenciasSeleccionadas)) {
            let ids=[];
            for (let index = 0; index < incidenciasSeleccionadas.length; index++) {
                const element = incidenciasSeleccionadas[index];
                ids.push(element.id);
            }
            servicioHttp.consumirPostHttp('incidencia/eliminar_in.json',ids).then(response => {
                this.setState({
                    mostrarModalConfirmacion:false,
                    incidenciasSeleccionadas:[]
                });
                this.consultarIncidencias();
            }).catch(error => {
                
            });
        }
    }

    mostrarModalConfirmacion = () => {
        this.setState({
            mostrarModalConfirmacion:true
        });
    }

    cerrarModalConfirmacion = () => {
        this.setState({
            mostrarModalConfirmacion:false
        });
    }

    exportarSua = () => {
        this.asignarRestricciones();
        let { paginacion }=this.state;
        servicioArchivos.descargaArchivo("incidencia/generar_sua_paginacion.json",paginacion);
    }

    columnaFormatoIncidencia = (rowData, column) =>{
        console.log("rowData.tipo: ",rowData.tipo);
        return servicioFormatos.formatoTipoIncidencia(rowData.tipo);
    }

    render() {

        let { errores, mostrarCalendarios, registrosPatronales, consulta, tipoDeIncidencias, paginacion, idsenube,
            incidenciasSeleccionadas, mostrarModalConfirmacion } = this.state;

        const pieModalConfirmacion = (
            <div>
                <Button label="Si estoy seguro" icon="pi pi-check" onClick={this.eliminarIncidencias} />
                <Button label="No estoy seguro" icon="pi-md-close" className="p-button-danger" onClick={this.cerrarModalConfirmacion} />
            </div>
        );    

        let calendarioInicial =
            <div className="p-col-12 p-md-5">
                <Calendar
                    id="consulta.fechaInicial"
                    name="consulta.fechaInicial"
                    value={consulta.fechaInicial}
                    placeholder="dd/mm/aaaa"
                    onChange={(e) => this.asignarValores(e, false)}
                    className={errores.fechaInicial ? 'p-error' : ''}
                    dateFormat={FORMATO_FECHA_CALENDAR}
                    locale={CALENDARIO_ES_MX}
                />
                {errores.fechaInicial ? <div><br /> <Message severity="error" text={errores.fechaInicial} /> </div> : null}
            </div>;

        let calendardioFinal =
            <div className="p-col-12 p-md-5">
                <Calendar
                    id="consulta.fechaFinal"
                    name="consulta.fechaFinal"
                    value={consulta.fechaFinal}
                    placeholder="dd/mm/aaaa"
                    onChange={(e) => this.asignarValores(e, false)}
                    className={errores.fechaFinal ? 'p-error' : ''}
                    dateFormat={FORMATO_FECHA_CALENDAR}
                    locale={CALENDARIO_ES_MX}
                />
                {errores.fechaFinal ? <div><br /> <Message severity="error" text={errores.fechaFinal} /> </div> : null}
            </div>;

        return (

            <div>
                <Growl ref={(el) => (this.growl = el)} />

                <div className="card">
                    <h1>BUSQUEDA DE INCIDENCIAS</h1>
                    <div className="p-grid">
                        <div className="p-col-12 p-md-3">
                            <label>* Registro Patronal:</label>
                        </div>
                        <div className="p-col-12 p-md-5">
                            <Dropdown filter={true} filterPlaceholder="Filtra por RP o Nombre corto" 
                            filterBy="value,label" showClear={true}
                                appendTo={document.body}
                                optionLabel="label"
                                style={{ width: "100%" }}
                                id="consulta.registroPatronal"
                                name="consulta.registroPatronal"
                                options={registrosPatronales}
                                value={consulta.registroPatronal}
                                onChange={(e) => this.asignarValores(e, false)} />
                            {errores.registroPatronal ? (<div><br /> <Message severity="error" text={errores.registroPatronal} />{" "}</div>) : null}
                        </div>
                        <div className="p-col-12 p-md-4">
                        </div>
                        <div className="p-col-12 p-md-3">
                            <label>* Tipo de incidencia:</label>
                        </div>
                        <div className="p-col-12 p-md-5">
                            <Dropdown
                                appendTo={document.body}
                                optionLabel="label"
                                style={{ width: "100%" }}
                                id="consulta.tipo"
                                name="consulta.tipoDeIncidencia"
                                options={tipoDeIncidencias}
                                value={consulta.tipoDeIncidencia}
                                onChange={(e) => this.asignarValores(e, false)} />
                            {errores.tipoDeIncidencia ? (<div><br /> <Message severity="error" text={errores.tipoDeIncidencia} />{" "}</div>) : null}
                        </div>
                        <div className="p-col-12 p-md-4">
                        </div>

                        <div className="p-col-12 p-md-3">
                            <label>* Fecha Inicial:</label>
                        </div>
                        {mostrarCalendarios ? calendarioInicial : null}

                        <div className="p-col-12 p-md-4">
                        </div>
                        <div className="p-col-12 p-md-3">
                            <label >* Fecha Final:</label>
                        </div>
                        {mostrarCalendarios ? calendardioFinal : null}
                        <div className="p-col-12 p-md-4">
                        </div>
                        <div className="p-col-12 p-md-3">
                            <Button
                                label="Limpiar"
                                icon="pi-md-refresh"
                                onClick={this.reiniciarFrmBusqueda} />
                        </div>
                        <div className="p-col-12 p-md-3">
                            <Button
                                label="Buscar"
                                icon="pi-md-search"
                                onClick={this.buscar} />
                        </div>
                    </div>
                </div>


                <div className="card">
                    <DataTable
                        value={paginacion.datos}
                        header="LISTADO DE INCIDENTES"
                        responsive={true}
                        resizableColumns={true}
                        autoLayout={true}>
                        <Column body={this.plantillaCheckBox} header="BORRAR" style={{ width: '2em' }} />
                        <Column field="Index" header="NO." body={this.onIndexTemplate} style={{ width: '100px' }} autoLayout={true} resizableColumns={true} />
                        <Column header="TIPO" body={this.columnaFormatoIncidencia} style={{ width: '120px' }} autoLayout={true} resizableColumns={true} />
                        <Column header="REGISTRO PATRONAL" field="registroPatronalEmpresa" style={{ width: '200px' }} autoLayout={true} resizableColumns={true} />
                        <Column header="NSS" field="nss" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                        <Column header="FECHA" body={this.templateFecha} style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                        <Column header="FOLIO" field="folioIncapacidad" style={{ width: '150px' }} autoLayout={true} resizableColumns={true} />
                        <Column header="DIAS" field="dias" style={{ width: '80px' }} autoLayout={true} resizableColumns={true} />
                    </DataTable>
                    <Paginator first={idsenube} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina} rowsPerPageOptions={[10, 20, 40, 60, 80, 100]} template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown" currentPageReportTemplate={"Total: " + paginacion.registrosTotales + ", Página ({currentPage} de {totalPages})"} />
                </div>
                <div className="card">
                    <div className="p-grid">
                        <div className="p-col-12 p-md-6">
                            <label></label>
                        </div>
                        <div className="p-col-12 p-md-3">
                            <Button label="Eliminar" icon="pi-md-delete" disabled={servicioObjetos.esObjetoVacio(incidenciasSeleccionadas)} onClick={this.mostrarModalConfirmacion} />
                        </div>
                        <div className="p-col-12 p-md-3">
                            <Button label="Exportar a Sua" icon="pi-md-import-export" disabled={servicioObjetos.esObjetoVacio(paginacion.datos)} onClick={this.exportarSua}/>
                        </div>
                    </div>
                </div>
                <Dialog appendTo={document.body} header="Confirmación" visible={mostrarModalConfirmacion} style={{ width: '50vw' }} modal={true} onHide={this.cerrarModalConfirmacion} footer={pieModalConfirmacion}>
                        ¿Estás seguro de eliminar {incidenciasSeleccionadas.length} incidencias?
                </Dialog>
            </div>
        );
    }

}